/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, bool, string, number, func, shape,
} from 'prop-types';
import { connect } from 'react-redux';
import * as Joi from 'joi-browser';
import { withRouter } from 'react-router';
import Media from 'react-media';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import { getFeatureFlags } from '../../utils/featureSelectors';
import Form from '../../common/Form';
import Loading from '../../common/Loading';
import { form as FormStyle } from '../../style/form';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import getSiteConfig from '../../utils/getSiteConfig';
import configENV from '../../config';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import AccountLeftMenu from '../../common/Desktop/AccountLeftMenu';
import { trackPage } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import GraphqlSeoHeadTags from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import AccountHome from '../MyAccount/AccountHome';

const { COULD_UPDATE_EMAIL_PREFERENCE_AFTER, PERSIST_KEY } = configENV;
const styles = ({ typography, palette }) => FormStyle(typography, palette);

class EmailPreference extends Form {
    state = {
        data: {
            optInOut: false,
        },
        errors: {},
    };

    schema = {
        optInOut: Joi.boolean().invalid(false),
    };

    componentDidMount = () => {
        this.props.fetchEmailPreference();
        this.props.fetchUserProfile();
    };

    componentWillReceiveProps = (props) => {
        const { data } = this.state;
        data.optInOut = !props.isSubscribed;
        this.setState({ data });
    };

    doSubmit = (submitData) => {
        const { data } = this.state;
        const { retrieveEmailMessage } = this.props;
        let requestAction = '';
        if (retrieveEmailMessage) {
            if (['Unsubscribed', 'Held'].includes(retrieveEmailMessage)) requestAction = 'SUBSCRIBE';
            else if (retrieveEmailMessage === 'NOTFOUND') requestAction = 'CREATE';
            else if (retrieveEmailMessage === 'Active') requestAction = 'DELETE';
        }
        data.requestAction = requestAction;
        submitData.handleUpdateEmailPreference(data);
    };

    signUpCopyTemplate = (isSubscribed, isUpdateAvailable) => {
        const subscribeInfo = (
            <>
                <p className="margin-bottom">
                    {isSubscribed
                        ? 'You are currently signed up to receive our emails!'
                        : 'Sign up to receive our emails!'}{' '}
                    You will be the first to know about{' '}
                    <strong>special offers</strong>, <strong>new gift</strong>{' '}
                    and <strong>dessert ideas</strong> and we will remind you
                    about upcoming gift occasions. Enjoy!
                </p>
            </>
        );

        const updateUnavailable = (
            <>
                {isSubscribed ? (
                    subscribeInfo
                ) : (
                    <p>
                        You have currently opted-out, you will no longer receive
                        these communications. However, you will continue to
                        receive email communications about the status of your
                        order.
                    </p>
                )}
            </>
        );

        return (
            <>
                {isUpdateAvailable ? subscribeInfo : updateUnavailable}
            </>
        );
    };

    optingOutCopy = () => (
        <>
            By opting-out, you will no longer receive these
            communications. However, you will continue to receive
            email communications about the status of your order.
        </>
    );

    catalogPreferenceCopy = () => (
        <>
            <p>
                <b>Catalog, Gift History &amp; Phone Preferences</b>
            </p>
            <p>
                Because we are committed to minimizing our impact on the
                environment, we do our best to deliver ONLY what you
                would like to receive. If you’d like to manage other
                communication preferences, please call our call center
                at {getSiteConfig('phoneNumber')}.
            </p>
        </>
    );

    mobileSignUpFormTemplate = (props) => {
        const {
            classes,
            isReadyState,
            userProfile,
            isSubscribed,
            timestamp,
            handleUpdateEmailPreference,
        } = props;
        const { data: { optInOut } } = this.state;
        const submitData = { handleUpdateEmailPreference };
        const currentTime = new Date().getTime();
        const elapsedTime = (currentTime - timestamp) / 1000;
        const isUpdateAvailable = elapsedTime > COULD_UPDATE_EMAIL_PREFERENCE_AFTER;
        const willBeAvaialableInMinutes = Math.floor((COULD_UPDATE_EMAIL_PREFERENCE_AFTER - elapsedTime) / 60);
        const readyLabel = isSubscribed ? 'Submit' : 'Sign Up';
        const notReadyLabel = isSubscribed ? 'Submitting...' : 'Signing Up...';
        const submitButtonLabel = isReadyState ? readyLabel : notReadyLabel;

        return (
            <>
                <div
                    className={
                        isUpdateAvailable
                            ? 'margin-top-2x row'
                            : 'margin-top-2x'
                    }
                >
                    <span className="bold">Current Email: </span>
                    {userProfile.email}
                </div>
                {isUpdateAvailable ? (
                    <form
                        onSubmit={(event) => this.handleSubmit(event, submitData)}     // eslint-disable-line arrow-parens
                        className={`${classes.form} row margin-top-2x`}
                        disabled={!isReadyState}
                    >
                        <div className={!isSubscribed ? 'display-none' : ''}>
                            {this.renderCheckbox({
                                isChecked: !optInOut,
                                value: 'optInOut',
                                className: 'checkboxHD',
                                onChange: '',
                                label: isSubscribed ? "I don't want to receive any special offers or emails." : 'I want to receive special offers.',
                            })}
                        </div>
                        <div className="margin-top-2x margin-bottom-2x opacity1">
                            {this.renderButton({
                                label: submitButtonLabel,
                                className: 'buttonHD',
                                onClick: null,
                                type: 'submit',
                                isValidated: true,
                                isReadyState,
                            })}
                        </div>
                    </form>
                ) : (
                    <div className="margin-top-2x margin-bottom-2x">
                        You can edit the preference after{' '}
                        {willBeAvaialableInMinutes > 0 ? `${willBeAvaialableInMinutes} minute(s).` : 'less than a minute.'}
                    </div>
                )}
                {isSubscribed && isUpdateAvailable ? (
                    <div className="margin-bottom-2x">
                        {this.optingOutCopy()}
                    </div>
                ) : (
                    ''
                )}
                <div className="margin-bottom-2x">
                    {this.catalogPreferenceCopy()}
                </div>
            </>
        );
    };

    desktopSignUpFormTemplate = (props) => {
        const {
            isReadyState,
            userProfile,
            isSubscribed,
            timestamp,
            handleUpdateEmailPreference,
        } = props;
        const { data: { optInOut } } = this.state;
        const submitData = { handleUpdateEmailPreference };
        const currentTime = new Date().getTime();
        const elapsedTime = (currentTime - timestamp) / 1000;
        const isUpdateAvailable = elapsedTime > COULD_UPDATE_EMAIL_PREFERENCE_AFTER;
        const willBeAvaialableInMinutes = Math.floor((COULD_UPDATE_EMAIL_PREFERENCE_AFTER - elapsedTime) / 60);
        const readyLabel = isSubscribed ? 'Submit' : 'Sign Up';
        const notReadyLabel = isSubscribed ? 'Submitting...' : 'Signing Up...';
        const submitButtonLabel = isReadyState ? readyLabel : notReadyLabel;
        return (
            <>
                <Grid item xs={10} style={{ padding: '20px 11px 0 43px' }}>
                    <form
                        onSubmit={(event) => this.handleSubmit(event, submitData)}     // eslint-disable-line arrow-parens
                        className="margin-top-2x"
                        disabled={!isReadyState}
                    >
                        <h2>EMAIL PREFERENCES </h2>
                        <Grid className="shadowContentGrid contentGrid" container item xs={12}>
                            <Grid className="block" item xs={12}>
                                <div className="blockHeader">Promotions and Offers </div>
                            </Grid>
                            <Grid className="blockContent no-margin-bottom" item xs={12}>
                                {this.signUpCopyTemplate(isSubscribed, isUpdateAvailable)}
                                <div
                                    className={
                                        isUpdateAvailable
                                            ? 'margin-top-2x row'
                                            : 'margin-top-2x'
                                    }
                                >
                                    <span className="gray-color">Current Email: </span>
                                    <span className="bold">{userProfile.email}</span>
                                </div>
                                {isUpdateAvailable ? (
                                    <div className={!isSubscribed ? 'display-none' : `${isSubscribed} test-class`}>
                                        {this.renderCheckbox({
                                            isChecked: !optInOut,
                                            value: 'optInOut',
                                            className: 'checkbox',
                                            onChange: '',
                                            label: isSubscribed ? "I don't want to receive any special offers or emails." : 'I want to receive special offers.',
                                            dataTest: { field: 'my-account-email-preference' },
                                        })}
                                    </div>
                                ) : (
                                    <div className="margin-top-2x margin-bottom-2x">
                                        You can edit the preference after{' '}
                                        {willBeAvaialableInMinutes > 0 ? `${willBeAvaialableInMinutes} minute(s).` : 'less than a minute.'}
                                    </div>
                                )}

                                {isSubscribed && isUpdateAvailable ? (
                                    <div className="margin-bottom-2x small gray-color margin-left">
                                        {this.optingOutCopy()}
                                    </div>
                                ) : (
                                    ''
                                )}
                                <div className="margin-bottom-2x">
                                    {this.catalogPreferenceCopy()}
                                </div>
                            </Grid>
                        </Grid>
                        <div className="align-right">
                            {this.renderButton({
                                label: submitButtonLabel,
                                className: '',
                                onClick: null,
                                type: 'submit',
                                isValidated: true,
                                isReadyState: isUpdateAvailable,
                            })}
                        </div>
                    </form>
                </Grid>
            </>
        );
    };

    render() {
        const {
            isFetchingModal,
            isSubscribed,
            userProfile,
            featureFlags,
            timestamp,
        } = this.props;
        const currentTime = new Date().getTime();
        const elapsedTime = (currentTime - timestamp) / 1000;
        const isUpdateAvailable = elapsedTime > COULD_UPDATE_EMAIL_PREFERENCE_AFTER;
        if (isFetchingModal) return <Loading pageTitle="Promotions and Offers" />;
        const breakpointExpr =  `(max-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
        return (
            <>
                <GraphqlSeoHeadTags seoData={{
                    page_title: 'My Account',
                    location: { pathname: '/account/email-preference' },
                }}
                />
                <Media query={breakpointExpr}>
                    {(matches) => (       // eslint-disable-line arrow-parens
                        matches ? (
                            <>
                                <h1>
                                    <AccountHome />
                                    Promotions and Offers
                                </h1>
                                {this.signUpCopyTemplate(isSubscribed, isUpdateAvailable)}
                                {this.mobileSignUpFormTemplate(this.props)}
                            </>
                        )
                            : (
                                <>
                                    <div className="container">
                                        <Grid container>
                                            <AccountLeftMenu
                                                userProfile={userProfile}
                                                featureFlags={featureFlags}
                                            />
                                            {this.desktopSignUpFormTemplate(this.props)}
                                        </Grid>
                                    </div>
                                </>
                            )
                    )}
                </Media>
            </>
        );
    }
}

EmailPreference.defaultProps = {
    isSubscribed: false,
    timestamp: 0,
    isFetchingModal: true,
    featureFlags: {},
    retrieveEmailMessage: '',
};

EmailPreference.propTypes = {
    classes: object.isRequired,
    isFetchingModal: bool,
    isSubscribed: bool,
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
    featureFlags: object,
    timestamp: number,
    fetchUserProfile: func.isRequired,
    history: object.isRequired,
    retrieveEmailMessage: string,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    let featureFlags = {};
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
            // eslint-disable-next-line no-empty
        } catch (ex) {}
    }
    return {
        isReadyState: newState.isReadyState,
        isFetchingModal: newState.isFetchingModal,
        toggleState: newState.toggleState,
        isSubscribed: newState.isSubscribed,
        email: newState.email,
        timestamp: newState.timestamp,
        errorMessage: newState.error ? newState.error.message : '',
        userProfile: newState.userProfile,
        history: newState.history,
        featureFlags,
        retrieveEmailMessage: newState.retrieveEmailMessage,
    };
};

const mapDispatchToProps = (dispatch) => ({   // eslint-disable-line arrow-parens
    fetchEmailPreference: () => dispatch(EventDispatcher.fetchEmailPreference()),
    handleUpdateEmailPreference: (data) => dispatch(EventDispatcher.handleUpdateEmailPreference(data)),      // eslint-disable-line arrow-parens
    fetchUserProfile: () => dispatch(EventDispatcher.fetchUserProfile()),
});

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    trackPage({
        type: 'emailpreference',
        name: 'MyAccount',
        accountPage: true,
    }),
    withRouter,
    withStyles(styles, { withTheme: true }),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);
export default enhance(EmailPreference);
